<template>
    <div class="warpper">
        <div class="classifys flex align-center">
            <router-link class="classify " to="/branch/notice/list">我发布的</router-link>
            <router-link class="classify active" to="/branch/notice">我接收的</router-link>
        </div>
        <div class="page-title line-height">通知公告</div>

        <empty v-if="lists.length===0" :type="4"/>

        <div v-else class="flex flex-direction">
            <div v-for="(item,index) in lists" :key="index" class="item-notice flex">
                <div class="flex flex-direction justify-between flex-sub overflow-hidden">
                    <div class="title ovHide">{{ item.title }}</div>
                    <div class="content ovHide">{{ item.content }}</div>
                    <div class="flex align-center">
                        <div :class="{ed:item.is_read ===1}" class="read">{{ item.is_read === 0 ? '未读' : '已读' }}</div>
                        <div v-if="item.is_need_feedback" :class="{yellow:item.is_read ===1}" class="time yellow">
                            {{ item.is_feedback === 0 ? '未反馈' : '已反馈' }}
                        </div>
                        <div class="time">{{ item.add_time }}</div>
                    </div>
                </div>
                <div class="flex align-center margin-left">
                    <el-button class="operate white" @click="toNoticeDetail(item.id)"><i class="el-icon-view"></i>查看
                    </el-button>
                    <el-button v-if="item.is_need_feedback" :class="{disabled:item.is_feedback}"
                               class="operate" @click="toFeedback(item.id)"><i
                        class="el-icon-chat-dot-square"></i>{{ item.is_feedback ? '已反馈' : '反馈' }}
                    </el-button>
                </div>
            </div>
        </div>
        <el-pagination
            v-if="lists.length>0"
            :current-page.sync="page"
            :page-size="limit"
            :total="total"
            background
            class="page-all margin-top"
            layout="prev, pager, next, jumper"
            @current-change="init">
        </el-pagination>
        <el-empty v-if="lists.length === 0" description="暂无数据"></el-empty>
        <notice-detail-dialog :detailDialogVisible="detailDialogVisible" :nid="cur_nid"
                              @watchState="watchState"></notice-detail-dialog>
        <notice-feedback-dialog :applyDialogVisible="applyDialogVisible" :nid="cur_nid"
                                @feedbackState="feedbackState"></notice-feedback-dialog>
    </div>
</template>

<script>
import {getNoticeList} from '@/api/branch'
import NoticeDetailDialog from "./../../components/NoticeDetailDialog.vue";
import {zhDate} from '@/utils/utils'
import {reg_html} from '@/utils/rules'
import NoticeFeedbackDialog from "./../../components/NoticeFeedbackDialog.vue";

export default {
    components: {
        NoticeFeedbackDialog,
        NoticeDetailDialog
    },
    name: "notice",
    data() {
        return {
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            cur_nid: 0,
            detailDialogVisible: false,
            applyDialogVisible: false
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.init()
    },
    computed: {},
    methods: {
        //  页面加载时请求
        async init() {
            let _data = await getNoticeList(this.page, this.limit)
            if (_data.status === 200) {
                _data.data.map(item => {
                    item.add_time = zhDate(item.add_time * 1000)
                    item.content = item.content.replace(reg_html, '').replace(/&nbsp;/ig, "")
                })
                this.lists = _data.data
                this.total = _data.count
            }
        },
        toNoticeDetail(id) {
            this.cur_nid = id
            this.detailDialogVisible = true;
        },
        watchState(state) {
            if (state) {
                this.init()
            } else {
                this.detailDialogVisible = false;
            }
        },
        toFeedback(id) {
            this.cur_nid = id
            this.applyDialogVisible = true;
        },
        feedbackState(state) {
            this.applyDialogVisible = false;
            if (state) {
                this.init()
            }
        },
    }

}
</script>

<style lang="scss" scoped>
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .classifys {
        margin-bottom: 20px;

        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            border-radius: 6px 0 0 6px;
            color: #ffb400;

            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 0 6px 6px 0;

            }
        }
    }

    .item-notice {
        width: 100%;
        min-height: 109px;
        background-color: #f3f7fb;
        border-radius: 10px;
        margin-top: 20px;
        padding: 11px 20px;

        .title {
            font-size: 20px;
            font-weight: bold;
            color: #0a2240;
        }

        .content {
            width: 100%;
            font-size: 14px;
            color: #7889a4;
        }

        .read {
            width: 39px;
            height: 16px;
            line-height: 16px;
            text-align: center;
            background-color: #ff9600;
            border-radius: 8px;
            font-size: 12px;
            margin-right: 8px;
            color: #ffffff;

            .ed {
                background-color: #8ba2c6;
            }
        }

        .time {
            font-size: 14px;
            color: #7889a4;
            margin-right: 8px;

            &.yellow {
                color: #ff9600;
            }
        }

        .operate {
            width: 99px;
            height: 40px;
            border-radius: 20px;
            font-size: 16px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#ff9600, #ff9600);
            background-blend-mode: normal, normal;
            color: #ffffff;

            &.white {
                background: #ffffff none;
                color: #ff9600;
            }

            &.disabled {
                background: #b4c7e5 none;
            }
        }
    }
}

</style>